import React from 'react';
import { withRouter, Route} from 'react-router-dom';

import './index.css' 

const OrgAdminArea = ( {match, history} ) => {
    history.push(match.url + '/OrgTeam')
    return (
        <div></div>
    )
}


export default withRouter(OrgAdminArea)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/index.js